import React from 'react';
import { CreditUsageByLogin } from '../usage/CreditUsageByLogin';
import { adminAPI } from '../../lib/api';

export function AiUsageByLoginTab() {
  return (
    <CreditUsageByLogin
      getReport={(month) => adminAPI.getAiUsageByLogin(month)}
      getTimeline={(rid, month) => adminAPI.getAiUsageLoginTimeline(rid, month)}
      onBackfill={() => adminAPI.backfillUsageLinks()}
      showCompany
      intro="Absolute credit usage by login across all companies. Expand a login to trace each candidate's journey — resume parse → ranking → assessment → interview questions → video interview — with credits at every step. Use 'Backfill history links' once to best-effort link older events to their candidate/job (estimated)."
    />
  );
}
